// extracted by mini-css-extract-plugin
module.exports = {"offerIcon":"styles_offerIcon__3gAOE"};